export default __webpack_public_path__ + "static/media/ico-clock.4cd0bb50.svg";